import React, { useState, useRef, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import externaluser from "../../../assets/images/externaluser.svg"
import internaluser from "../../../assets/images/internaluser.svg";
import { AllUsers } from "../../../interfaces/identity/calendar/Events";
import Attendees from "../../../assets/images/AddAttendees.svg";
import { IoClose } from "react-icons/io5";
import { FiChevronDown } from "react-icons/fi";
import { GetUserWhoNotHaveEmails } from "../../../utilities/common/commonFuntion";


interface ParticipantSelectDropdownProps {
  label?: string;
  name: string;
  participantUserIds: string[];
  externalUserEmails: string[];
  onChange: (data: { participantUserIds: string[]; externalUserEmails: string[] }) => void;
  options: AllUsers[];
  error?: string;
}

const ParticipantSelectDropdown: React.FC<ParticipantSelectDropdownProps> = ({
  label,
  name,
  participantUserIds,
  externalUserEmails,
  onChange,
  options,
  error,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(0);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const ChevronDown = FiChevronDown as any;
  const Close = IoClose as unknown as React.FC<React.SVGProps<SVGSVGElement>>;


  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSelectUser = useCallback((user: AllUsers) => {
    const newParticipantUserIds = participantUserIds.includes(user.userId)
      ? participantUserIds.filter(id => id !== user.userId)
      : [...participantUserIds, user.userId];
    onChange({ participantUserIds: newParticipantUserIds, externalUserEmails });
    setSearchTerm("");
    setIsOpen(false);
  }, [participantUserIds, externalUserEmails, onChange]);

  const handleRemoveUser = (userId: string) => {
    const newParticipantUserIds = participantUserIds.filter(id => id !== userId);
    onChange({ participantUserIds: newParticipantUserIds, externalUserEmails });
  };

  const handleRemoveEmail = (email: string) => {
    const newExternalUserEmails = externalUserEmails.filter(e => e !== email);
    onChange({ participantUserIds, externalUserEmails: newExternalUserEmails });
  };

  const selectedUsers = options.filter(user => participantUserIds.includes(user.userId));

  const filteredOptions = options.filter(option =>
    !participantUserIds.includes(option.userId) &&
    option.userName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const emailToAdd = searchTerm.trim();
  const isEmailValid = emailRegex.test(emailToAdd);
  const canAddEmail = isEmailValid && !externalUserEmails.includes(emailToAdd);

  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!isOpen) {
      if (e.key === 'ArrowDown' || e.key === 'Enter') {
        e.preventDefault();
        setIsOpen(true);
      }
      return;
    }

    const totalOptions = filteredOptions.length + (canAddEmail ? 1 : 0);

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setHoveredIndex(prev => (prev + 1) % totalOptions);
        break;
      case 'ArrowUp':
        e.preventDefault();
        setHoveredIndex(prev => (prev - 1 + totalOptions) % totalOptions);
        break;
      case 'Enter':
      case 'Tab':
      case ' ':
        if (searchTerm.trim() === "" && e.key === ' ') return;
        e.preventDefault();
        if (hoveredIndex < filteredOptions.length) {
          if (filteredOptions[hoveredIndex]) {
            handleSelectUser(filteredOptions[hoveredIndex]);
          }
        } else if (canAddEmail) {
          const newExternalUserEmails = [...externalUserEmails, emailToAdd];
          onChange({ participantUserIds, externalUserEmails: newExternalUserEmails });
          setSearchTerm("");
          setIsOpen(false);
        }
        break;
      case 'Escape':
        e.preventDefault();
        setIsOpen(false);
        break;
    }
  }, [isOpen, searchTerm, filteredOptions, hoveredIndex, externalUserEmails, participantUserIds, canAddEmail, emailToAdd, handleSelectUser, onChange]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isOpen) setHoveredIndex(0);
  }, [isOpen]);

  useEffect(() => {
    setHoveredIndex(0);
  }, [searchTerm]);

  const hasSelectedParticipants =
    participantUserIds.length > 0 || externalUserEmails.length > 0;

    const usersWithoutEmailDetails = React.useMemo(() => {
        const usersWithoutEmail = GetUserWhoNotHaveEmails(options, participantUserIds);
        const userIdSet = new Set(usersWithoutEmail);
        return options.filter(user => userIdSet.has(user.userId));
    }, [participantUserIds, options]);



  return (
    <div className="relative w-full" ref={dropdownRef}>
      {/* {label && <label className="block text-[#212121] font-medium text-sm mb-1">{label}</label>} */}
      <div
        className={`min-h-[48px] border-x-[1px] border-t-2 border-[#F5F6F7] ps-2 pr-2.5 gap-x-1 gap-y-1.5 flex flex-wrap items-center cursor-pointer focus:outline-none focus:ring-0`}
        onClick={() => {
          setIsOpen(prev => !prev);
          if (!isOpen) {
            inputRef.current?.focus();
          }
        }}
      >
        <div className="flex items-center justify-start add-attendence">
          <img
            src={Attendees}
            alt="Attendees"
            className=""
          />
        </div>
        {/* {selectedUsers.map(user => (
          <span key={user.userId} className={`group !text-[13px] font-medium rounded-full whitespace-nowrap inline-flex items-center gap-1.5 ${user.type === 'employee' ? 'bg-red-100 text-red-800' : 'bg-purple-100 text-purple-800'}`}>
            <img src={user.type === 'employee' ? externaluser : internaluser} alt={user.type} className="w-4 h-4 ml-1" />
            <div className="ps-1 py-1">{user.userName}</div>
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); handleRemoveUser(user.userId); }}
              className="text-gray-500 w-4 h-4 me-1 text-base cursor-pointer rounded-full hover:text-red-500"
              aria-label={`Remove ${user.userName}`}
            >
              <Close />
            </button>
          </span>
        ))} */}
        {selectedUsers.map(user => (
          <span
            key={user.userId}
            className={`inline-flex items-center gap-1.5 px-2 py-1 text-[13px] font-medium rounded-md border border-gray-300 whitespace-nowrap capitalize ${user.type === 'employee' ? 'bg-[#6999ff2d] text-blue-600' : 'bg-red-50 text-[#D32F2F]'}`}
          >
            <div className="ps-1">
              {user.userName}
            </div>

            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveUser(user.userId);
              }}
              className="text-[#747474] w-4 h-4 text-base cursor-pointer rounded hover:text-gray-600"
              aria-label={`Remove ${user.userName}`}
            >
              <Close />
            </button>
          </span>
        ))}

        {externalUserEmails.map(email => (
          <span key={email} className="group bg-gray-200 text-gray-800 text-xs font-medium rounded-full inline-flex items-center gap-1.5">
            <div className="ps-2 py-1">{email}</div>
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); handleRemoveEmail(email); }}
              className="text-[#747474] w-4 h-4 me-1 text-base  cursor-pointer rounded-full hover:text-red-500"
              aria-label={`Remove ${email}`}
            >
              <Close />
            </button>
          </span>
        ))}

        <div className="relative flex-grow min-w-[120px]">

          {/* {!hasSelectedParticipants && !isOpen && (
          )} */}
          <input
            ref={inputRef}
            type="text"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setIsOpen(true);
            }}
            onKeyDown={handleKeyDown}
            placeholder={!hasSelectedParticipants ? "Add Attendees" : ""}
            className={`w-full bg-transparent outline-none border-0 focus:ring-0 p-0 
      !text-[13px] 2xl:!text-[16px] font-normal`}
          />
        </div>

        <ChevronDown
          className={`absolute top-5 right-3 transition-transform duration-200 pointer-events-none ${isOpen ? "rotate-180" : ""}`}
          size={18}
          color="#777"
        />
      </div>
      {isOpen && (
        <ul className="absolute
      left-1/2
      -translate-x-1/2
      z-[100]
      w-[90%]
      mt-1
      bg-white
      border border-gray-300
      rounded-lg
      shadow-lg
      max-h-44
      overflow-y-auto
      p-0">
          {/* {filteredOptions.map((option, index) => {
            return <li
              key={option.userId}
              onClick={() => handleSelectUser(option)}
              onMouseEnter={() => setHoveredIndex(index)}
              className={`px-3 py-2 cursor-pointer transition-colors duration-100 text-sm flex items-center ${index === hoveredIndex ? 'bg-gray-100' : ''
                }`}
            >
              <img src={option.type === 'employee' ? externaluser : internaluser} alt={option.type} className="w-6 h-6 mr-2" />

              {option.userName}
              {option.type}
            </li>;
          })} */}
          {filteredOptions.map((option, index) => {
            return <li
              key={option.userId}
              onClick={() => handleSelectUser(option)}
              onMouseEnter={() => setHoveredIndex(index)}
              className={`
      flex items-center gap-3 px-2 py-1.5 cursor-pointer
      transition-colors duration-150
      ${index === hoveredIndex ? "bg-[#F9F6FF]" : ""}
    `}
            >
              {/* Avatar */}
              {/* <img
                src={(option.type === "employee" ? internaluser : externaluser)}
                alt={option.userName}
                className="w-9 h-9 rounded-full object-cover flex-shrink-0"
              /> */}

              <div className="relative w-9 h-9 flex-shrink-0">
                <img
                  src={option.avatar || (option.type === "employee" ? internaluser : externaluser)}
                  alt={option.userName}
                  className={`w-9 h-9 rounded-full object-cover border-2  
                    ${option.type === "employee" ? "border-[#6999FF]" : "border-[#D32F2F]"}`}
                />

                {/* Online status dot */}
                {/* <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 border-2 border-white rounded-full"></span> */}
              </div>


              {/* Text content */}
              <div className="">
                <p className="text-sm font-medium text-gray-900 leading-tight m-0 capitalize">
                  {option.userName}
                </p>
                <p className="text-xs text-gray-500 !text-start m-0 capitalize">
                  {option?.role}
                </p>
              </div>
            </li>;
          })}

          {canAddEmail && (
            <li
              onClick={() => {
                const newExternalUserEmails = [...externalUserEmails, emailToAdd];
                onChange({ participantUserIds, externalUserEmails: newExternalUserEmails });
                setSearchTerm("");
                setIsOpen(false);
              }}
              onMouseEnter={() => setHoveredIndex(filteredOptions.length)}
              className={`px-3 py-2 cursor-pointer transition-colors duration-100 text-sm ${hoveredIndex === filteredOptions.length ? 'bg-gray-100' : ''
                }`}
            >
              Add email: {searchTerm}
            </li>
          )}
          {filteredOptions.length === 0 && !canAddEmail && searchTerm && (
            <li className="px-3 py-2 text-gray-500 text-sm">No users found</li>
          )}
        </ul>
      )}
          {
              usersWithoutEmailDetails.length > 0 && (
                  <div className={`mt-1 mb-1 pl-4 pr-4 text-xs ${error === "SomeParticipantNoEmail" ? "text-danger" : "text-warning"}`}>
                      {usersWithoutEmailDetails.map((user, index) => (
                          <span key={user.userId} className="capitalize font-medium">
                              {user.userName}
                              {index === usersWithoutEmailDetails.length - 2 && " and "}
                              {index < usersWithoutEmailDetails.length - 2 && ", "}
                          </span>
                      ))}
                      <span className="font-medium">
                          {" "}participant{usersWithoutEmailDetails.length > 1 ? "s" : ""} does not have an email — please add an email before creating the event.
                      </span>
                  </div>
              )}


      {error &&  error != "SomeParticipantNoEmail" && <p className="text-red-500 text-sm ps-10">{error}</p>}
    </div>
  );
};

export default ParticipantSelectDropdown;